module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "pagex"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "contentsHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_ack01#ack01"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_fm01#fm01"
    }
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_fm03#fm03"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber1"
  }, [_c('a', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt01#pt01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part I: Ruling Today, Preparing to Rule Tomorrow")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt01#ch01"
    }
  }, [_vm._v("1. An Honest Assessment")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt01#ch02"
    }
  }, [_vm._v("2. Your Needs Now and in Retirement")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt01#ch03"
    }
  }, [_vm._v("3. Creating a Profile and Looking Ahead")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt01#ch04"
    }
  }, [_vm._v("4. Social Security and Your Retirement")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt01#ch05"
    }
  }, [_vm._v("5. Saving for College")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt01#ch06"
    }
  }, [_vm._v("6. Real Estate")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt01#ch07"
    }
  }, [_vm._v("7. Insurance")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt01#ch08"
    }
  }, [_vm._v("8. Estate Planning")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber1"
  }, [_c('span', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt02#pt02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part II: Mastering the Tools")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt02#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Stocking Away Your Cash")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt02#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Mutual Funds—The Good, the Mediocre, and the Downright Horrible")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt02#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Bonds and Bond Funds")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt02#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Almighty Buck")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt02#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Asset Allocation")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber1"
  }, [_c('span', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt03#pt03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part III: Making the Most of It")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt03#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Looking to Trends")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt03#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Trading the Gaps")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_pt03#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Trading Options for Retirement")])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_bm01#bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ruleyourfreakinretirement_bm02#bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-064d1494","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ruleyourfreakinretirement_con01.vue
// module id = 72
// module chunks = 0